'use strict';

const jQuery = require('jquery');

const ContentManager = require('./../component/ContentManager');
const SaveManager = require('./../component/SaveManager');

module.exports.vertical = function(contentSet, content, config) {
    let dfd = jQuery.Deferred();
    let oldCloudContentSet = content.getCloudContentSet();
    let oldColContentSet = content.getColContentSet();

    ContentManager.createElement('ColContentSet').done(function(colContentSet) {
        colContentSet.setElements([{'type': content.type, 'uid': content.uid}]);

        SaveManager.save().done(function() {
            colContentSet.getHtml().done(function($html) {
                let $div = jQuery('<div></div>');

                ContentManager.removeHtml(content, oldCloudContentSet, oldColContentSet);

                $div.append($html);

                if (config.prev.length) {
                    $div.insertAfter(config.prev);
                } else {
                    $div.insertBefore(config.next);
                }

                contentSet.buildColumn();

                contentSet.setUpdated(true);

                dfd.resolve();
            });
        });
    });

    return dfd.promise();
};

const betweenHorizontal = function(contentSet, content, config) {
    let dfd = jQuery.Deferred();
    let oldColContentSet = content.getColContentSet();
    let oldCloudContentSet = content.getCloudContentSet();
    let $oldHtml = content.$;

    content.getHtml().done(function($html) {
        let data;
        let $colContentSet;

        content.$ = $oldHtml;

        data = ContentManager.removeHtml(content, oldCloudContentSet, oldColContentSet);

        content.$ = $html;

        if (config.next.length) {
            $html.insertBefore(config.next);
        } else {
            $html.insertAfter(config.prev);
        }

        $colContentSet = config.next.length ? config.next.parent() : config.prev.parent();

        contentSet.setUpdated(true);

        if (data.transform) {
            ContentManager.transformColContentSet($colContentSet).done(function() {
                dfd.resolve();
            });
        } else {
            dfd.resolve();
        }
    });

    return dfd.promise();
};

module.exports.horizontal = function(contentSet, content, config) {
    if (config.$zone.hasClass('horizontal-between')) {
        return betweenHorizontal(contentSet, content, config);
    }

    let dfd = jQuery.Deferred();
    let oldCloudContentSet = content.getCloudContentSet();
    let oldColContentSet = content.getColContentSet();

    ContentManager.createElementWithSub('CloudContentSet', 'ColContentSet')
                  .done(function(cloudContentSet, colContentSet) {
            colContentSet.setElements([{'type': content.type, 'uid': content.uid}]);

            SaveManager.save().done(function() {
                cloudContentSet.getHtml().done(function($html) {
                    ContentManager.removeHtml(content, oldCloudContentSet, oldColContentSet);

                    if (config.next.length) {
                        $html.insertBefore(config.next);
                    } else {
                        $html.insertAfter(config.prev);
                    }

                    contentSet.setUpdated(true);

                    dfd.resolve();
                });
            });
        });

    return dfd.promise();
};
